import { render } from "./ChannelManagement.vue?vue&type=template&id=112b8a32"
import script from "./ChannelManagement.vue?vue&type=script&lang=js"
export * from "./ChannelManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__